import {
    objectTypes,
    humanFields,
    carFields,
    animalFields,
    techniqueFields,
    objectType,
    trailerFields,
} from '@api/Devices.api';

export enum itemTypes {
    text = 'text',
    date = 'date',
}

export type itemType = `${itemTypes}`;

export interface IDeviceAdditionalItem {
    name: string;
    type: itemType;
}

export const getDeviceObjectKeys = (
    type: objectType,
): IDeviceAdditionalItem[] => {
    let items: IDeviceAdditionalItem[] = [];
    const regExp = /(d|D)ate/;
    if (type === objectTypes.human) {
        items = Object.values(humanFields).map((name) => ({
            name,
            type: regExp.test(name) ? itemTypes.date : itemTypes.text,
        }));
    } else if (type === objectTypes.car) {
        items = Object.values(carFields).map((name) => ({
            name,
            type: regExp.test(name) ? itemTypes.date : itemTypes.text,
        }));
    } else if (type === objectTypes.animal) {
        items = Object.values(animalFields).map((name) => ({
            name,
            type: regExp.test(name) ? itemTypes.date : itemTypes.text,
        }));
    } else if (type === objectTypes.technique) {
        items = Object.values(techniqueFields).map((name) => ({
            name,
            type: regExp.test(name) ? itemTypes.date : itemTypes.text,
        }));
    }else if (type === objectTypes.trailer) {
        items = Object.values(trailerFields).map((name) => ({
            name,
            type: regExp.test(name) ? itemTypes.date : itemTypes.text,
        }));
    }
    return items;
};
